import React, { useState } from "react";
import "/app/components/LandingPage/Landing.css";

const CardServices = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const briefContent = props.serviceContent.slice(0, 150) + "...";

  return (
    <div className="col-md-4">
      <div className="section_our_solution">
        <div className="our_solution_category">
          <div className="solution_cards_box">
            <div className="solution_card">
              <div className="hover_color_bubble"></div>
              <div className="so_top_icon">
                <img src={props.serviceImg} />
              </div>
              <div className="solu_title">
                <h3> {props.serviceTitle}</h3>
              </div>
              <div className="solu_description">
                {/* <p>

                        {props.serviceContent}
                        </p> */}
                <p>{isExpanded ? props.serviceContent : briefContent}</p>
                <button
                  type="button"
                  className="read_more_btn float-right mt-3"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? "Less" : "More"}
                </button>
                {/* <button
                          type="button"
                          className="read_more_btn float-right mt-3"
                        >
                          Read More
                        </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardServices;
